import { Component, Vue } from 'vue-property-decorator'
import CACG1120ViewModel from './CACG1120ViewModel'
import CACG1120Service from './CACG1120Service'

import CACG1110ParamModel from '../CACG1110/CACG1110ParamModel'
import CACG1130ParamModel from '../CACG1130/CACG1130ParamModel'

import TransportService from '@/common/TransportService'
import CommonConstants from '@/common/CommonConstants'
import { FormatConstants } from '@/common/FormatConstants'
import { fixedContent } from '@/assets/js/main.js'
import { nextTick } from 'process'
import CommonUtil from '@/common/utils/CommonUtil'
@Component({
  name: 'CACG1120'
  })
export default class CACG1120Controller extends Vue {
  private isCompleteLoading = false
  private FormatConstants = FormatConstants
  private CommonConstants = CommonConstants
  private cacg1120ViewModel: CACG1120ViewModel = {
    productNameInformal: '',
    productDivName: '',
    productDiv2: '',
    productNo: '',
    shhnCd: '',
    typeProduct: null,

    operatProductMaterialInfo: {
      operatProductMaterialInfoPdfName: '',
      operatProductMaterialInfoPdfLnkUrl: ''
    },
    formulaMVAInfo: {
      formulaMVAPdfName: '',
      formulaMVAPdfLnkUrl: ''
    },
    operatProductPdfInfo: {
      operatProductPdfName: '',
      operatProductPdfLnkUrl: ''
    }
  }

  private cacg1120Service = new CACG1120Service()

  /**
   * 画面要素描画後処理
   */
  async mounted() {
    fixedContent()
    await this.init()
    nextTick(() => {
      fixedContent()
    })
  }

  /**
   * 初期処理
   */
  private async init() {
    const productNo = JSON.parse(
      JSON.stringify(this.$route.query.productNo || '')
    )
    const shhnCd = JSON.parse(JSON.stringify(this.$route.query.shhnCd || ''))

    this.cacg1120ViewModel.productNo = productNo
    this.cacg1120ViewModel.shhnCd = shhnCd
    const params = `shhnCd=${this.cacg1120ViewModel.shhnCd}`
    const [
      caca1060ResponseModel,
      transportResponseModel
    ] = await Promise.all([
      this.cacg1120Service.callAPICACA1120(
        productNo,
        shhnCd
      ),
      // 稼働／閲覧統計ログを実行する
      TransportService.callAPITransportWithLogMode(CommonConstants.URL_CACG1120, null, params, CommonConstants.LOG_MODE_ACCESS_ONLY)
    ])

    this.cacg1120ViewModel.productDivName =
      caca1060ResponseModel?.productDivName
    this.cacg1120ViewModel.productNameInformal =
      caca1060ResponseModel?.productNameInformal
    this.cacg1120ViewModel.productDiv2 = caca1060ResponseModel?.productDiv2

    if (
      caca1060ResponseModel.productDiv2 === this.CommonConstants.INSURANCE_VALUE
    ) {
      this.cacg1120ViewModel.typeProduct = '保証利率'
    } else if (
      caca1060ResponseModel.productDiv2 === this.CommonConstants.DEPOSIT_VALUE
    ) {
      this.cacg1120ViewModel.typeProduct = '適用利率'
    }

    this.cacg1120ViewModel.operatProductMaterialInfo =
      caca1060ResponseModel.operatProductMaterialInfo ?? null
    this.cacg1120ViewModel.formulaMVAInfo =
      caca1060ResponseModel.formulaMVAInfo ?? null
    this.cacg1120ViewModel.operatProductPdfInfo =
      caca1060ResponseModel.operatProductPdfInfo ?? null

    this.isCompleteLoading = true
  }

  /**
   * 保証利率/適用利率タブ切り替え
   */
  private gotoCACG1110() {
    const cacg1110ParamModel: CACG1110ParamModel = {
      productNo: this.cacg1120ViewModel.productNo,
      shhnCd: this.cacg1120ViewModel.shhnCd
    }

    this.$router.push({
      name: 'cacg1110',
      query: cacg1110ParamModel
    })
  }

  /**
   * チャートタブ切り替え
   */
  private gotoCACG1130() {
    const cacg1130ParamModel: CACG1130ParamModel = {
      productNo: this.cacg1120ViewModel.productNo,
      shhnCd: this.cacg1120ViewModel.shhnCd
    }

    this.$router.push({
      name: 'cacg1130',
      query: cacg1130ParamModel
    })
  }

  /**
   * 運用商品ラインアップに戻るリンク押下
   */
  private gotoCACG1010() {
    this.$router.push({ name: 'cacg1010' })
  }

  /**
   * 商品説明資料一覧リンク押下
   * 解約控除計算式PDFリンク押下
   * @param pdfFilePath
   */
  private async openPDF(pdfFilePath: string) {
    window.open(pdfFilePath, '_blank')
  }
}
